import React, { Fragment } from 'react';
import { 
  Edit,
  EditProps,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
  ImageInput,
  ImageField,
  BooleanInput
} from 'react-admin'
import { makeStyles } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import UploadImages from '../products/UploadImages';
import RichTextInput from 'ra-input-rich-text';

const useStyles = makeStyles((table) => ({
  description: {
    width:600
  },
  content:{
    width:800
  }
}))

const RecipeTitle = (props: any) => {
  const { record } = props;
  const translate = useTranslate();
  return record ? (
      <span>
          {translate('resources.recipes.name', { smart_count: 1 })}
      </span>
  ) : null;
};

const PreviewImage = ({ record, source }:any) => {
  if (typeof (record) == "string") {
      record = {
          [source]: record
      }
  }
  return <ImageField record={record} source={source} />
}

const RecipeEdit = (props: EditProps) => {

const classes = useStyles();
 return (
   <Fragment>
      <Edit title={<RecipeTitle/>} {...props}>
        <SimpleForm>
        <TextInput source="name_en" validate={required()} label="Name (English)"/>
            <TextInput source="name_ar" validate={required()} label="Name (Arabic)"/>
            <UploadImages sourceName="featured_image1" multiple={false} />
            <UploadImages sourceName="images1" multiple={true} />
            <RichTextInput source="ingredients_en" label="Ingredients (English)"/>
            <RichTextInput source="ingredients_ar" label="Ingredients (Arabic)"/>
            <RichTextInput source="instruction_en" label="Instructions (English)"/>
            <RichTextInput source="instruction_ar" label="Instructions (Arabic)"/>
            <BooleanInput source="active" defaultValue={true} />
        </SimpleForm>
      </Edit>
   </Fragment>
 )
}

export default RecipeEdit;